// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import AwardJapanStandardLarge from '../_raw/award/icon_award_japan_standard_large.svg';
import withIconProps from '../withIconProps';

export default withIconProps(AwardJapanStandardLarge, { shouldSetDefaultSize: false });
